import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="number"][maxlength]'
})
export class MaxlengthNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement) {
    const maxLength = input.getAttribute('maxlength');
    const value = input.value;
    if (maxLength && value.length > parseInt(maxLength)) {
      input.value = value.slice(0, parseInt(maxLength));
    }
  }
}
